import { countryLocaleMappings } from '../constants/dataConstants';
export const NumberFormatter = (countryCode: string, amount: number ) => {

    const locale=countryLocaleMappings[countryCode];

	return amount?.toLocaleString(locale)
};

export const FormatLocalizedNumber = (
  countryCode: string,
  amount: number | string | undefined
): string => {
  if (amount == null || amount === "-") return "-";

  const locale = countryLocaleMappings[countryCode] || "en-US";
  const num = Number(amount);

  if (isNaN(num)) return "-";
  const truncated = Math.trunc(parseFloat((num * 100).toFixed(8))) / 100;
  return truncated.toLocaleString(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};
